import React from "react";
import { formatDateToTimeStampte } from "../../helpers/function";
import { useTranslation } from "react-i18next";

const TreatmentHistory = ({ treatments, claim }) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  return ready ? (
    <>
      <div className="kt-heading kt-heading--md">
        {t("Historique de traitement")}
      </div>
      {!["incomplete", "full"].includes(claim?.status) && (
        <div className="kt-wizard-v2__review-item">
          {!claim ? null : (
            <>
              {" "}
              <div className="kt-wizard-v2__review-title">
                <h5>
                  <span style={{ color: "#48465b" }}>
                    {t("Unité traitante")}
                  </span>
                </h5>
              </div>
              <div className="kt-wizard-v2__review-content">
                <strong>{t("Unité")}</strong>:{" "}
                <span className="mx-2">
                  {claim?.active_treatment?.responsible_unit?.name?.fr ?? "-"}
                </span>
                <br />
              </div>
            </>
          )}
        </div>
      )}
      {treatments?.map?.((item, index) => (
        <div className="kt-wizard-v2__review-item mb-3" key={index}>
          {!item.invalidated_reason ? (
            <div className="kt-wizard-v2__review-title">
              <h5>
                <strong>{t("Traitement validé")}</strong>
              </h5>
            </div>
          ) : null}

          <div className="kt-wizard-v2__review-content jumbotron px-2 py-2 mb-0">
            {item.responsible_unit ? (
              <>
                <strong>{t("Unité traitante")}</strong>:{" "}
                <span className="mx-2">{item.responsible_unit}</span>
                <br />
              </>
            ) : null}
            {item.responsible_staff ? (
              <>
                <strong>{t("Responsable d'unité")}</strong>:{" "}
                <span className="mx-2">{item.responsible_staff}</span>
                <br />
              </>
            ) : null}
            {item.unfounded_reason ? (
              <>
                <strong>{t("Raison du non fondé")}</strong>:{" "}
                <span className="mx-2">{item.unfounded_reason}</span>
                <br />
              </>
            ) : null}
            {item.amount_returned ||
            item.solution ||
            item.preventive_measures ||
            item.comments || item.cause ? (
              <>
                <strong>{t("Montant")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {item.amount_returned ? item.amount_returned : "-"}
                </span>
                <br />
                <strong>{t("Solution")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {item.solution ? item.solution : "-"}
                </span>
                <br />
                <strong>{t("Mesure preventive")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {item.preventive_measures ? item.preventive_measures : "-"}
                </span>
                <br />
                <strong>{t("Commentaire")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {item.comments ? item.comments : "-"}
                </span>
                <br />
                <strong>{t("Cause")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {item.cause ? item.cause : "-"}
                </span>
                <br />
              </>
            ) : null}

            {item?.solved_at ? (
              <>
                <strong>{t("Date de traitement")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {formatDateToTimeStampte(item.solved_at)}
                </span>
                <br />
              </>
            ) : null}

            {item?.invalidated_reason ? (
              <>
                <strong>{t("Motif du rejet")}</strong>:{" "}
                <span className="mx-2 text-danger">
                  {item.invalidated_reason}
                </span>
                <br />
              </>
            ) : null}

            {item.validated_at ? (
              <>
                <strong>{t("Date de validation du traitement")}</strong>:{" "}
                <span
                  className={`mx-2 ${
                    !item.invalidated_reason ? "text-success" : ""
                  }`}
                >
                  {formatDateToTimeStampte(item.validated_at)}
                </span>
                <br />
              </>
            ) : null}
          </div>
        </div>
      ))}
    </>
  ) : null;
};

export default TreatmentHistory;
